import {
  Chart as ChartJS,
  LinearScale,
  TimeScale,
  RadialLinearScale,
  CategoryScale,
  LineController,
  RadarController,
  LineElement,
  PointElement,
  Legend,
  Tooltip,
} from "chart.js";

import {
  AlarmLevel,
  CrosshairPlugin,
  ExternalTooltipCleanupPlugin,
  HtmlLegendPlugin,
  DrawConnectingLinesPlugin,
  DrawOrbitConnectingLinesPlugin,
  HarmonicCursorsPlugin,
  SubHarmonicCursorsPlugin,
  AdditionalCursorLabelsPlugin,
  FaultFrequenciesCursorsPlugin,
  MarkerPassageLinesPlugin,
  SelectionZoomPlugin,
} from "./components/common/chart-plugins";

ChartJS.register(
  LinearScale,
  TimeScale,
  RadialLinearScale,
  CategoryScale,
  LineController,
  RadarController,
  LineElement,
  PointElement,
  Legend,
  Tooltip,
  AlarmLevel,
  SelectionZoomPlugin,
  CrosshairPlugin,
  ExternalTooltipCleanupPlugin,
  HtmlLegendPlugin,
  DrawConnectingLinesPlugin,
  DrawOrbitConnectingLinesPlugin,
  HarmonicCursorsPlugin,
  SubHarmonicCursorsPlugin,
  AdditionalCursorLabelsPlugin,
  FaultFrequenciesCursorsPlugin,
  MarkerPassageLinesPlugin,
);
